<!-- https://github.com/angular/angular/issues/24567 -->
@if (isExternalUrl()) {
  <a
    [href]="url"
    [attr.target]="target"
    [attr.rel]="rel"
    [attr.id]="id"
    [attr.class]="class"
    [attr.style]="style"
    [attr.title]="title"
    [tabIndex]="0"
    role="button"
    [attr.aria-label]="title">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <a
    [routerLink]="routerUrl"
    [routerLinkActive]="['active']"
    [routerLinkActiveOptions]="matchOptions"
    [queryParams]="queryParams"
    [fragment]="fragment"
    [target]="target"
    [attr.id]="id"
    [attr.class]="class"
    [attr.style]="style"
    [attr.title]="title"
    [tabIndex]="0"
    role="button"
    [attr.aria-label]="title">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}


<ng-template #content>
  <ng-content></ng-content>
</ng-template>
